import cornerYellow from "./cy.png";
import paternYellow from "./py.png";
import kangoro1 from "./kan1.png";
import kangoro2 from "./kan2.png";
import kangoro3 from "./kan3.jpg";
import kangoro4 from "./kan4.jpg";
import mojhayerRangarang from "./moj.svg";
import cornerFirouz from "./cf.png";
import paternFirouz from "./pf.png";
import samour1 from "./sam1.png";
import samour2 from "./sam2.png";
import samour3 from "./sam3.jpg";
import samour4 from "./sam4.jpg";
import virgilYellow from "./vy.png";
import virgilFirouz from "./vf.png";
import paye56 from "./p56.jpg";
import paye78 from "./p78.jpg";
import mostatil from "./mostatil.png";
import logofatemi from "./logofatemi.png";
import jumpingoro from "./jumgoro.gif";
import amini from "./amini.png";
import c1 from "./c1.jpg"
import c2 from "./c2.jpg"
import c3 from "./c3.jpg"
import c4 from "./c4.jpg"
import bebNav from "./bebras-navbar.jpg"
import d57 from "./57demo.jpg"
import d58 from "./58demo.jpg"
import samandkan from "./samkan.png"
import samourSimple from './samourSimple.png'
import kangoroSimple from './kangoroSimple.png'
import kanandsamteach from './kanandsamteach.png'

import d55 from "./55.jpg"
import d56 from "./56.jpg"

export {
  cornerYellow,
  paternYellow,
  kangoro1,
  kangoro2,
  mojhayerRangarang,
  cornerFirouz,
  paternFirouz,
  samour1,
  samour2,
  virgilYellow,
  virgilFirouz,
  kangoro3,
  samour3,
  kangoro4,
  samour4,
  paye56,
  paye78,
  mostatil,
  logofatemi,
  jumpingoro,
  amini,
  c1,
  c2,
  c3,
  c4,
  bebNav,
  d57,
  d58,
  d55,
  d56,
  samandkan,
  samourSimple,
  kangoroSimple,
  kanandsamteach
};
